import i18n from '@/lang'

export default [
  {
    path: '/patient/:id',
    // component: Patient,
    component: () => import('@/layouts/Patient/index'),
    meta: {
      title: i18n.t('router.patient.text_1'),
      requireAuth: true,
      isSupportMobile: true
    },
    children: [
      {
        name: 'patientSummary',
        path: '',
        // component: Summary,
        component: () => import('@/pages/Patient/Summary'),
        meta: {
          title: i18n.t('router.patient.text_1'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientProfile',
        path: 'profile',
        // component: Profile,
        component: () => import('@/pages/Patient/Profile'),
        meta: {
          title: i18n.t('router.patient.text_2'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientExercise',
        path: 'exercise',
        // component: PatientExercise,
        component: () => import('@/pages/Patient/Exercise/Template'),
        meta: {
          title: i18n.t('router.patient.text_3'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientSchedule',
        path: 'schedule',
        // component: Schedule,
        component: () => import('@/pages/Patient/Schedule'),
        meta: {
          title: i18n.t('router.patient.text_4'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientRecord',
        path: 'record',
        // component: AllRecord,
        component: () => import('@/pages/Patient/Activity/AllRecord'),
        meta: {
          title: i18n.t('router.patient.text_5'),
          requireAuth: true,
          isSupportMobile: true
        }
      },
      {
        name: 'patientScore',
        path: 'score',
        // component: ScoreList,
        component: () => import('@/pages/Patient/Scores/ScoreList'),
        meta: {
          title: i18n.t('router.patient.text_6'),
          requireAuth: true,
          isSupportMobile: true
        }
      }
    ]
  },
  {
    name: 'updatePatientExercise',
    path: '/patient/:id/exercise/update',
    // component: UpdateExercise,
    component: () => import('@/pages/Patient/Exercise/Update'),
    meta: {
      title: i18n.t('router.patient.text_7'),
      requireAuth: true
    }
  },
  {
    name: 'recordDetail',
    path: '/patient/:id/record/:exerciseId',
    // component: RecordDetail,
    component: () => import('@/pages/Patient/Activity/RecordDetail'),
    meta: {
      title: i18n.t('router.patient.text_8'),
      requireAuth: true
    }
  },
  {
    name: 'scoreDetail',
    path: '/patient/:id/score/:scoreId',
    // component: ScoreDetail,
    component: () => import('@/pages/Patient/Scores/ScoreDetail'),
    meta: {
      title: i18n.t('router.patient.text_9'),
      requireAuth: true
    }
  },
  {
    name: 'patientUpgrade',
    path: '/patient/:id/upgrade',
    // component: LevelUpgrade,
    component: () => import('@/pages/Patient/LevelUpgrade'),
    meta: {
      title: i18n.t('router.patient.text_10'),
      requireAuth: true
    }
  },
  {
    name: 'levelHistoryReport',
    path: '/patient/:id/level/:level',
    // component: LevelHistoryReport,
    component: () => import('@/pages/Patient/LevelHistoryReport'),
    meta: {
      title: i18n.t('router.patient.text_11'),
      requireAuth: true
    }
  },
  {
    name: 'patientPainFeedback',
    path: '/patient/:id/feedback/pain/:painId',
    // component: PainFeedback,
    component: () => import('@/pages/Patient/PainFeedback'),
    meta: {
      title: i18n.t('router.patient.text_12'),
      requireAuth: true
    }
  },
  {
    name: 'modifyLevelOfSchedule',
    path: '/patient/:id/schedule/level/:level',
    // component: ModifyLevelOfSchedule,
    component: () => import('@/pages/Patient/Schedule/ModifyLevelOfSchedule'),
    meta: {
      title: i18n.t('router.patient.text_13'),
      requireAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/patient.js